<template lang="html">
  <div class="offers-admin-wrapper">
    <div class="title">
      Ponude
    </div>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr>
            <td>datum</td>
            <td>kupac</td>
            <td>cena</td>
            <td>valuta</td>
            <td>količina</td>
            <td>status</td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="offer in offers" :key="offer.off_id">
            <td>
              {{ offer.off_date }}
            </td>
            <td>
              {{ offer.usr_name }}
            </td>
            <td>
              {{ offer.prc_price }}
            </td>
            <td>
              {{ offer.cur_id }}
            </td>
            <td>
              {{ offer.off_quantity }}
            </td>
            <td>
              {{ getStatus(offer.off_status) }}
            </td>
            <td>
              <div @click="openAd(offer.pro_id)" class="btn">
                otvori
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="offers.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import Paginate from "vuejs-paginate";
import { api } from "@/api";
export default {
  name: "offersAdmin",
  components: {
    Paginate
  },
  data() {
    return {
      offers: [],
      page: 1,
      pageCount: 0
    };
  },
  mounted() {
    this.getOffers();
  },
  methods: {
    getOffers() {
      let params = {
        page: this.page
      };
      api.getAllOffers(params).then(res => {
        this.offers = res.data.data;
        this.pageCount = res.data.page_count;
      });
    },
    openAd(id) {
      let params = Object.assign({}, this.$route.params);
      params.id = id;
      this.$router.push({ name: "Details", params: params });
    },
    getPaginationImages(side) {
      let path = require(`@/assets/icons/pagination${side}.png`);
      return `<img src='${path}' alt='pagination left image'>`;
    },
    changePage(page) {
      this.page = page;
      this.getOffers();
    },
    getStatus(status) {
      if (status === 1) {
        return this.$t("profile.buyers.statusSold");
      } else if (status === 2) {
        return this.$t("profile.buyers.statusBuyerGaveUp");
      } else if (status === 3) {
        return this.$t("profile.buyers.statusRejected");
      } else if (status === 4) {
        return this.$t("profile.buyers.statusRejectedAdmin");
      } else if (status === 5) {
        return this.$t("profile.buyers.statusContract");
      } else {
        return this.$t("profile.buyers.statusUnknown");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.offers-admin-wrapper {
  @import "@/assets/scss/tableStyles.scss";
  @import "@/assets/scss/btnStyles.scss";
  padding-left: 40px;
  box-sizing: border-box;
  height: 100%;
  position: relative;

  .table-wrapper {
    height: calc(100% - 160px);
    overflow: auto;
  }

  .title {
    margin-bottom: 40px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
  }
  .switcher {
    display: flex;
    flex-direction: row;
    .btn {
      width: 150px;
    }
  }
}
</style>
